/**
 * Table cell popin display.
 * @public
 */
enum TableColumnPopinDisplay {
	/**
	 * default type
	 * @public
	 */
	Block = "Block",

	/**
	 * inline type (the title and value are displayed on the same line)
	 * @public
	 */
	Inline = "Inline",
}

export default TableColumnPopinDisplay;
